import { render } from "./InboxItem.vue?vue&type=template&id=4c0268e2"
import script from "./InboxItem.vue?vue&type=script&lang=js"
export * from "./InboxItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__